import { PartnerSectionProps } from "@/src/sections/partner";

export const partnersSectionData_ar: PartnerSectionProps = {
  sectionHeading: {
    subtitle: "شركائنا",
    title: "تحالفاتنا الاستراتيجية",
  },
  cards: Array.from({ length: 30 }, (_, index) => ({
    img: `/assets/images/partnerbasic/partner${index + 1}.webp`,
  })),
};
